import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OhcService } from '@confectionary-app/service/ohc.service';
import { ComponentType, HxAuthService, HxStoreService, HxUiLabelPipe, HxUserService, StoreFullModel } from 'hx-services';
import { environment } from '@confectionary-env/environment';
import { FormsModule } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';
import { HxLanguageSelectComponent } from 'hx-component';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * Component of sidebar with mainmenu
 */
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
  imports: [FormsModule, NgFor, NgIf, TranslocoPipe, HxUiLabelPipe, HxLanguageSelectComponent]
})
export class SidebarComponent implements OnInit {
  menuList = [
    'order-stats',
    'order-list',
    'process',
    'history',
    'invoices',
    'storage',
  ];
  appVersion = environment.version;
  showSidebar = false;
  store: StoreFullModel;
  authUserFullname!: string;

  constructor(
    private router: Router,
    private ohcService: OhcService,
    private storeService: HxStoreService,
    private userService: HxUserService,
    private auth: HxAuthService,
  ) { }

  async ngOnInit() {
    this.authUserFullname = this.auth.user.fullname;

    const storeId = this.ohcService.getStoreId();
    if (storeId) {
      this.getStore(storeId);

      if (storeId !== this.auth.user.store.id) {
        // Сессия одна на все приложения, и этот вызов переписывает магазин в том числе для
        // кассы. Раньше сюда без проверки уезжало значение из localStorage: чужая точка,
        // оставшаяся в браузере, молча становилась текущей, и касса пробивала заказы на неё.
        const allowedStores = await this.storeService.getAllStoresByCurrentUserAndComponentType(ComponentType.cf);
        if (allowedStores.some(item => item.id === storeId)) {
          this.updateDefaultStore(storeId);
        } else {
          this.ohcService.clearStoreId();
          this.router.navigateByUrl('/verify');
        }
      }
    }
  }

  private getStore(storeId: number) {
    this.storeService.getFullStore(storeId).then(result => {
      this.store = result;
    }, err => {
      console.error(err);
    });
  }

  private updateDefaultStore(storeId: number) {
    this.userService.setDefaultStore(storeId).subscribe(() => {
      document.location.reload();
    }, err => {
      console.error(err);
    });
  }

  goPage(item) {
    this.closeSidebar();
    this.router.navigateByUrl(`/${item}`);
  }

  logout() {
    this.closeSidebar();
    this.ohcService.logout();
  }

  private closeSidebar() {
    this.showSidebar = false;
  }
}
